<template>
  <div class="mine-wrapper">
    <div class="upper-wrapper">
      <div class="village-wrapper" @click="villageSelect(1)">
        <img src="../../assets/images/index-village.png">{{villageName}}<img src="../../assets/images/village-arrow.png" style="padding-top: 6px">
      </div>
      <div class="information-wrapper" @click="$router.push({name: 'MyApproval'})" v-if="villageId && memberId">
        <img src="../../assets/images/index-information-bj.png">
        <div class="information-detail">
          <div>审批</div>
          <div>点击查看</div>
        </div>
      </div>
      <div class="information-wrapper" @click="clickRepair" v-if="authorityJudgment">
        <img src="../../assets/images/index-information-bj.png">
        <div class="information-detail">
          <div>报修管理</div>
          <div>点击查看</div>
        </div>
      </div>
      <div class="information-wrapper" @click="clickMaterial" v-if="villageId && memberId">
        <img src="../../assets/images/index-information-bj.png">
        <div class="information-detail">
          <div>物资管理</div>
          <div>点击查看</div>
        </div>
      </div>
      <div class="information-wrapper" @click="clickScanCode" v-if="permissionSign.indexOf('travel_code_veriry') >= 0 || permission === 'administrators'">
        <img src="../../assets/images/index-information-bj.png">
        <div class="information-detail">
          <div>出行管控</div>
          <div>扫一扫</div>
        </div>
      </div>
    </div>
    <div class="lower-wrapper">
      <div class="navigation active">
        <img src="../../assets/images/navigation-index-highlight.png">
        <div>首页</div>
      </div>
      <div class="navigation" @click="jumpLink">
        <img src="../../assets/images/navigation-mine.png">
        <div>我的</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Index',
  metaInfo: {
    title: '首页'
  },
  data () {
    return {
      info: '',
      authorityJudgment: false // 权限判断
    }
  },
  computed: {
    ...mapState(['villageId', 'villageName', 'appid', 'openid', 'permission', 'permissionSign', 'headPortrait', 'usertel', 'memberId'])
  },
  created () {
    this.getVillageList()
    this.getBindTel()
    // 权限判断 有维修员或者是主管身份能看到模块,没有就看不到
    if (this.permission === '') {
      this.authorityJudgment = false
    } else {
      this.authorityJudgment = true
    }
    let url = window.location.href.split('#')[0]
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        console.log('成功')
      })
      this.wx.error(function (res) {
        console.log('失败')
      })
    })
  },
  methods: {
    getVillageList () {
      // 获取小区列表
      this.axios.get('/wechat/index/getUserVillageList/openid/' + this.openid + '/tel/' + this.usertel + '/authorizer_appid/' + this.appid)
        .then((res) => {
          if (res.data.data === null) {
            this.$router.push({name: 'Account'})
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
    },
    // 去报修管理
    clickRepair: function () {
      if (this.villageName === '请选择小区') {
        this.$toast({
          message: '请先选择小区',
          duration: 3000
        })
        return false
      }
      this.$router.push({name: 'RepairCenter'})
    },
    // 选择小区
    villageSelect (e) {
      this.$router.push({name: 'Village', query: {index: e}})
    },
    // 跳转
    jumpLink () {
      this.$router.push({name: 'Mine'})
    },
    getBindTel () {
      this.axios.post('/wechat/index/bindTel/', {
        openid: this.openid,
        authorizer_appid: this.appid,
        tel: this.usertel,
        head_portrait: this.headPortrait
      }).then((res) => {
        if (res.data.status === 1) {
          console.log(res)
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 去物资管理
    clickMaterial () {
      console.log(this.$router)
      this.$router.push({name: 'Material'})
    },
    // 去扫码
    clickScanCode () {
      // var result = {'room_id': 200, 'user_id': '60', 'nickname': 'chenyang', 'user_tel': '18686523495', 'head_portrait': 'https:////thirdwx.qlogo.cn//mmopen//vi_32//DYAIOgq83eoROicgMicbkS4H3ZccHUBQeDqT4iayD8RQfa2YJfnVKhHD7JRycUILoxTwibwusQYwJHUKkDhbcqpb0A//132'}
      // this.$router.push({name: 'CodeMessage', query: {info: result}})
      let that = this
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          result = JSON.parse(result)
          if (result === '') {
            this.$toast({
              message: '未获取到用户信息',
              duration: 2000
            })
            return false
          }
          that.$router.push({name: 'CodeMessage', query: {info: result}})
        }
      })
    }
  }
}
</script>
<style scoped>
.mine-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.mine-wrapper .upper-wrapper {
  height: calc(100% - 64px);
  background-color: #f6f6f6;
  padding: 0 15px;
  position: relative;
}
.mine-wrapper .lower-wrapper {
  display: flex;
  font-size: 12px;
  background-color: #ffffff;
  height: 64px;
}
.mine-wrapper .lower-wrapper .navigation {
  flex: 1;
  text-align: center;
  color: #a8a8a8;
}
.mine-wrapper .lower-wrapper .navigation img {
  width: 21px;
  height: 21px;
  margin: 12px 0 2px 0;
}
.mine-wrapper .lower-wrapper .active {
  color: #2d2d2d;
}
.mine-wrapper .village-wrapper {
  text-align: left;
  padding: 15px 0 ;
  font-size: 18px;
}
.mine-wrapper .village-wrapper img {
  width: 17px;
  height: 17px;
  vertical-align: top;
  padding: 4px 8px 0 0;
}
.mine-wrapper .village-wrapper img:last-child {
  width: 14px;
  height: 14px;
  padding: 4px 0 0 4px;
}
.mine-wrapper .information-wrapper {
  position: relative;
  margin-bottom: 10px;
}
.mine-wrapper .information-wrapper img {
  width: 100%;
}
.mine-wrapper .information-wrapper .information-detail {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
.mine-wrapper .information-wrapper .information-detail div:first-child {
  color: #000000;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 2px;
  padding: 15px 27px 0 27px;
}
.mine-wrapper .information-wrapper .information-detail div:last-child {
  color: #ffaf14;
  font-size: 14px;
  letter-spacing: 1px;
  margin-top: 2px;
  padding: 0 27px;
}
</style>



// WEBPACK FOOTER //
// src/components/Index/Index.vue